/* eslint-disable no-unused-vars */
import { Badge, Box, Button, Flex, Heading, HStack, Image, Text, VStack } from '@chakra-ui/react';
import { PreOffersContainer } from '../components/LandingPageComponents/styles/SplashStyles';
import placeholderA from '../assets/placeholderA.png';
import placeholder from '../assets/videoPlaceholder.png';
import { useNavigate } from 'react-router-dom';
import { downArrow } from './dashboard/components/Icons';
import { useScreenWidth } from 'hooks/useScreenWidth';
import { useSelector } from 'react-redux';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';
const PreOffers = () => {
    const navigate = useNavigate();
    const screen = useScreenWidth();
    const productReducer = useSelector((state) => state.productReducer);
    const { products, loading, categories } = productReducer;
    const topEight = products && products?.items?.length > 0 ? products?.items?.slice(0, 8) : [];

    return (
        <PreOffersContainer>
            <Flex
                w="full"
                h="full"
                justify="center"
                alignItems="center"
                flexDir="column"
                pb={{ base: 0, lg: '2rem' }}>
                <Heading
                    as="h2"
                    w="90%"
                    mb="5px"
                    color="#090A0A"
                    fontSize="32px"
                    lineHeight="36px"
                    display={{ base: 'flex', lg: 'none' }}>
                    See Pre Offers
                </Heading>
                <Heading
                    display={{ base: 'none', lg: 'block' }}
                    as="h2"
                    w="90%"
                    mb="5px"
                    color="#090A0A"
                    fontSize="29px"
                    lineHeight="36px">
                    Welcome! See Pre Offers
                </Heading>
                <Box w="95%" ml="auto" mr="auto" mt="30px">
                    <HStack
                        w="100%"
                        gap={{ base: '5%', lg: '0' }}
                        mx="auto"
                        justifyContent="space-evenly"
                        alignItems="start"
                        flexWrap="wrap">
                        {topEight?.map((item) => {
                            const image = item?.cf_singleimage
                                ? JSON.parse(item?.cf_singleimage)
                                : [];
                            return (
                                <Box
                                    key={item.item_id}
                                    w={{ base: '45%', lg: '24%' }}
                                    py="12px"
                                    borderRadius="8px"
                                    mb="2rem"
                                    style={{ marginBottom: '2rem' }}
                                    border="1.2px solid #EEEEEE">
                                    <Box
                                        margin="auto"
                                        height="120px"
                                        w="100%"
                                        borderRadius="8px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        pos="relative"
                                        mb="20px">
                                        <Image
                                            src={image?.[0] || placeholderA}
                                            w="full"
                                            alt={item?.name || 'Product image'}
                                            objectFit="cover"
                                            h="10rem"
                                            fallbackSrc={placeholderA}
                                        />
                                        {/* {item?.available_stock <= 0 && (
                                            <Box
                                                pos={'absolute'}
                                                top={-2}
                                                right={0}
                                                px={1}
                                                background={'red.500'}
                                                textColor={'white'}
                                                shadow={'dark-lg'}
                                                fontSize={'xs'}>
                                                Out Of Stock
                                            </Box>
                                        )} */}
                                    </Box>
                                    <VStack alignItems="start">
                                        <Text
                                            color="#999999"
                                            fontSize="12px"
                                            lineHeight="16px"
                                            pl="10px">
                                            {item?.brand}
                                        </Text>
                                        <Text
                                            color="#000"
                                            lineHeight="20px"
                                            mt="0"
                                            pl="12px"
                                            fontSize="14px"
                                            isTruncated
                                            w={'full'}
                                            fontWeight="700">
                                            {item?.name}
                                        </Text>
                                        <Text
                                            color="#000"
                                            pl="12px"
                                            pb="4px"
                                            fontSize="14px"
                                            lineHeight="20px"
                                            mb="12px">
                                            <WalletHistoryPrice price={item?.rate ?? 0} />
                                            {/* <b style={{ fontWeight: 400, color: '#DCDCDC' }}>
                                                Pack of {item?.cf_packs}
                                            </b> */}
                                        </Text>
                                        <Text
                                            color="#000"
                                            fontSize="12px"
                                            fontWeight="300"
                                            opacity={0.6}
                                            w="full"
                                            px="10px"
                                            pt="12px"
                                            lineHeight="20px"
                                            borderTop="1.6px solid #EEEEEE">
                                            Earn Up to{' '}
                                            <WalletHistoryPrice price={(3 / 100) * item.rate} />
                                            /Pack
                                        </Text>
                                    </VStack>
                                </Box>
                            );
                        })}
                    </HStack>

                    <Button
                        w="100%"
                        color="#F5F5F5"
                        bg="#1b3b5f"
                        mt="20px"
                        fontWeight="400"
                        borderRadius="48px"
                        outline="none"
                        onClick={() =>
                            navigate(screen > 500 ? '/dashboard/actions' : '/actions', {
                                replace: true,
                            })
                        }>
                        {/* onClick={() => navigate('/actions', { replace: true })}> */}
                        Set up Store
                    </Button>
                </Box>
            </Flex>
            <VStack display={{ base: 'none', lg: 'flex' }} minW="400px" bg="#F2F4F5" p="30px">
                <Box bg="white" w="full" p="20px 30px">
                    <Flex justify="space-between" alignItems="center">
                        <Badge
                            bg="#1b3b5f"
                            color="white"
                            p="7px 9px"
                            textTransform="capitalize"
                            borderRadius="8px"
                            fontWeight="400"
                            fontSize="10px"
                            lineHeight="20px">
                            Step 1
                        </Badge>
                        <Text color="#AFAFAF" fontWeight="400" fontSize="11px" lineHeight="20px">
                            &lt; 1min
                        </Text>
                    </Flex>
                    <Heading fontWeight="500" py="12px" fontSize="15px" lineHeight="20px">
                        Agent Training & Certification
                    </Heading>
                    <Text
                        color="#AFAFAF"
                        fontWeight="400"
                        fontSize="12px"
                        lineHeight="15px"
                        w="90%">
                        In order to start selling you have to have a Obana store. Start your free
                        trial of Obana.
                    </Text>
                    <Button
                        bg="#1b3b5f"
                        color="white"
                        p="7px 14px"
                        mt="15px"
                        textTransform="capitalize"
                        borderRadius="4px"
                        fontWeight="400"
                        fontSize="11px"
                        lineHeight="20px">
                        Start Training
                    </Button>
                </Box>
                <Box w="full" p="40px">
                    <Flex justify="space-between" alignItems="center" mb="20px">
                        <Text color="#181717" fontWeight="500" fontSize="15px" lineHeight="20px">
                            Remaining Steps
                        </Text>
                        <span>{downArrow}</span>
                    </Flex>

                    <Button
                        disabled={true}
                        w="full"
                        textAlign="left"
                        p="2px 24px 2px 60px"
                        display="flex"
                        fontWeight="400"
                        justifyContent="space-between"
                        cursor="not-allowed"
                        rounded="none"
                        fontSize="12px"
                        mb="10px"
                        _hover={{
                            bg: 'white',
                        }}
                        _disabled={{
                            bg: 'white',
                        }}>
                        <Text color="#AFAFAF" fontSize="12px">
                            Upload Certificate
                        </Text>
                        <span>{downArrow}</span>
                    </Button>

                    <Button
                        disabled={true}
                        w="full"
                        textAlign="left"
                        p="2px 24px 2px 60px"
                        display="flex"
                        fontWeight="400"
                        justifyContent="space-between"
                        cursor="not-allowed"
                        rounded="none"
                        fontSize="12px"
                        mb="10px"
                        _hover={{
                            bg: 'white',
                        }}
                        _disabled={{
                            bg: 'white',
                        }}>
                        <Text color="#AFAFAF" fontSize="12px">
                            Complete Profile{' '}
                        </Text>
                        <span>{downArrow}</span>
                    </Button>

                    <Button
                        disabled={true}
                        w="full"
                        textAlign="left"
                        p="2px 24px 2px 60px"
                        display="flex"
                        fontWeight="400"
                        justifyContent="space-between"
                        cursor="not-allowed"
                        rounded="none"
                        fontSize="12px"
                        mb="10px"
                        _hover={{
                            bg: 'white',
                        }}
                        _disabled={{
                            bg: 'white',
                        }}>
                        <Text color="#AFAFAF" fontSize="12px">
                            Complete Profile{' '}
                        </Text>
                        <span>{downArrow}</span>
                    </Button>
                </Box>

                <Box>
                    <Image src={placeholder} />
                </Box>
            </VStack>
        </PreOffersContainer>
    );
};

export default PreOffers;
